// Centralised dates for the Sitare Admissions portal.
// Update these year-over-year and the rest of the UI follows.

export const ADMISSION_YEAR = 2026;

// Gates the login form: applications are visible only between these dates.
export const APPLICATION_OPEN_DATE = new Date('2026-04-08');
export const APPLICATION_CLOSE_DATE = new Date('2026-08-01');

// User-facing strings shown to applicants.
export const APPLICATION_OPEN_DISPLAY = 'April 20th, 2026';
export const APPLICATION_EDIT_DEADLINE_DISPLAY = 'July 31, 2026';

// Financial year used on ITR attachment labels (e.g. "2025-26").
export const ITR_FINANCIAL_YEAR = '2025-26';

// Year shown on the parents' income certificate attachment label.
export const PARENTS_INCOME_CERT_YEAR = ADMISSION_YEAR;

// Filenames offered when the applicant downloads the admissions leaflet.
export const LEAFLET_DOWNLOAD_FILENAME_EN = `${ADMISSION_YEAR}_Sitare_University_Admissions_Leaflet.pdf`;
export const LEAFLET_DOWNLOAD_FILENAME_HI = `${ADMISSION_YEAR}_Sitare_University_Admissions_Leaflet.pdf`;
